/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  makeStyles,
} from "@material-ui/core";
import { BiChevronDown } from "react-icons/bi";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(1.5),
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  popoverRoot: {
    marginTop: "-5px",
  },
  listRoot: {
    padding: "0px",
  },
  listItem: {
    fontSize: "16px",
    minWidth: "300px",
    padding: "20px",
    "&::before": {
      content: `""`,
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "1px",
      backgroundColor: "#ECEFF1",
      top: "0",
      left: "15px",
    },
    "&:hover": {
      backgroundColor: "#ECEFF1",
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "10px",
    },
  },
  filterTitleAndIcon: {
    display: "flex",
    alignItems: "center",
  },
  popoverTitle: {
    padding: "20px",
  },
  selectedOptionContainer: {
    ...theme.box,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "7px",
    paddingBottom: "7px",
    "&:hover": {
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "5px",
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "7px",
  },
  selectedOptionLabel: {
    display: "inherit",
    alignItems: "inherit",
    overflow: "hidden",
  },
}));

const SelectorComponent = ({
  defaultOption,
  onChange,
  options,
  icon,
  title,
  style = {},
  disabled,
  defaultOptionKey,
}) => {
  const classes = useStyles();
  const initialSelection =
    defaultOptionKey !== undefined
      ? _.find(options, (option) => option.key === defaultOptionKey) || {}
      : options[defaultOption] || {};
  const [selectedOption, setSelectedOption] = useState(initialSelection);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSelectClick = (event) => {
    event.stopPropagation();
    if (!disabled) setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (option) => {
    if (option.key !== selectedOption.key) setSelectedOption(option);
    setAnchorEl(null);
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (onChange) onChange(selectedOption);
  }, [selectedOption]);

  useEffect(() => {
    if (!_.find(options, ["key", selectedOption.key]))
      setSelectedOption(initialSelection);
  }, [options]);

  return (
    <>
      <div
        role="presentation"
        onClick={handleSelectClick}
        className={classes.selectedOptionContainer}
        style={style}
      >
        <Box className={classes.selectedOptionLabel}>
          {icon && <Box className={classes.iconContainer}>{icon}</Box>}
          <Typography variant="body2" noWrap>
            {selectedOption.label || title}
          </Typography>
        </Box>
        {!disabled && <BiChevronDown size={20} style={{ minWidth: "20px" }} />}
      </div>
      <Popover
        className={classes.popoverRoot}
        open={Boolean(anchorEl)}
        onClose={handleOnClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          component="span"
          className={`${classes.popoverTitle} ${classes.filterTitleAndIcon}`}
        >
          <Typography variant="body1" className={classes.alignCenterFlex}>
            <b>{title}</b>
          </Typography>
        </Box>
        <List className={classes.listRoot}>
          {_.map(options, (option) => {
            return (
              <ListItem
                onClick={() =>
                  handleListItemClick({
                    key: option.key,
                    label: option.label,
                  })
                }
                className={classes.listItem}
                key={option.key}
              >
                {option.icon}
                <Typography variant="body1">{option.label}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
};

export default SelectorComponent;
